/**
 * Revision route client
 */

import type {
  CreateRevisionLicensesAPIResponse,
  ListRevisionLicensesAPIResponse,
} from '../../routes/revisionLicenses';
import type {
  ListRevisionDeepLicensesResponse,
  ListRevisionDeepTodosResponse
} from '../../typings/api';
import type { RevisionLicense } from '../../typings/common';
import { get, post } from '../redux/api';
import { nuc } from '../utils';

export const getRevisionDeepLicenses = async (locator: string) => {
  const resp = await get<ListRevisionDeepLicensesResponse>(`/api/revisions/${nuc(locator)}/deeplicenses`);

  return resp?.data;
};

export const getRevisionDeepTodos = async (locator: string, counts?: boolean) => {
  const resp = await get<ListRevisionDeepTodosResponse>(
    `/api/revisions/${nuc(locator)}/todos`,
    false,
    counts ? { counts: true } : undefined,
  );

  return resp?.data;
};

export const getRevisionLicenses = async (locator: string) => {
  const resp = await get<ListRevisionLicensesAPIResponse>(`/api/revisions/${nuc(locator)}/licenses`);

  return resp?.data;
};

export const createRevisionLicense = (locator: string, body: RevisionLicense) => {
  return post<RevisionLicense, CreateRevisionLicensesAPIResponse>(
    `/api/revisions/${nuc(locator)}/licenses`,
    body,
  );
};
